import { GroupFragment } from 'graphql/types'

export interface ManageEventsProps {
  group: GroupFragment
}

export const ManageEvents = ({ group }: ManageEventsProps) => {
  return <div></div>
}
